import {EntityService} from '../../service/EntityService';

export class ActionLogService extends EntityService {

  static entity = 'app/acction-log';
}
